import { render, staticRenderFns } from "./surepay.vue?vue&type=template&id=5d5575be&"
import script from "./surepay.vue?vue&type=script&lang=js&"
export * from "./surepay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports